import { Component, OnInit } from "@angular/core";
import { SessionStorage } from "ngx-webstorage";
import { Profile } from "./profile";
import { MatDialog, MatSnackBar } from "@angular/material";
import { ProfileService } from "./profile.service";
import { VerticalDepartmentPopUpComponent } from "../vertical-department-pop-up/vertical-department-pop-up.component";
import { LandingService } from "../landing/landing.service";
@Component({
  selector: "app-profile",
  templateUrl: "./profile.component.html",
  styleUrls: ["./profile.component.css"],
})
export class ProfileComponent implements OnInit {
  @SessionStorage("user") public updatedUser;
  @SessionStorage() public user;
  public buttonPressed: boolean = false;
  public submitted: boolean = false;
  public profile = new Profile({});
  public confirmPwd: string = "";
  public notMatch: boolean = false;
  public barLabel: string = "Password strength:";
  constructor(
    private snackBar: MatSnackBar,
    private profileService: ProfileService,
    public vertInfoDialog: MatDialog
  ) {}

  ngOnInit() {}

  /**Function to enable chnage password*/
  changePwd() {
    this.buttonPressed = true;
  }

  /**Function to enable change password*/
  savePwd() {
    if (this.profile.newpwd == this.confirmPwd) {
      this.notMatch = false;
    } else {
      this.notMatch = true;
    }
  }

  editUnit() {
    const dialogRef = this.vertInfoDialog.open(
      VerticalDepartmentPopUpComponent,
      {
        width: "25%",
        data: {
          name: this.user.Empname,
          unitData: {
            unit: this.user.unit,
            vertical: this.user.vertical,
            department: this.user.department,
          },
        },
      }
    );

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        let data = {
          Empno: this.user.Empno,
          updateItems: result,
        };
        this.profileService.updateDepartInfo(data).subscribe(
          (res) => {
            if (res) {
              this.updatedUser = res.payload;
              this.snackBar.open("Updated Successfully", "OK", {
                duration: 3000,
              });
            }
          },
          (error) => {
            // this.spinnerService.hide();
            if (error.status === 404) {
              this.snackBar.open("Invalid Credentials", "OK", {
                duration: 3000,
              });
            }
          }
        );
      }
    });
  }

  /**Function to update password*/
  updatePassword(valid) {
    this.submitted = true;
    if (valid && !this.notMatch) {
      this.profile.empno = this.user.Empno;
      this.profileService.changePwd(this.profile).subscribe(
        (response) => {
          if (response.success) {
            this.buttonPressed = false;
            this.snackBar.open("Password changed Successfully", "OK", {
              duration: 3000,
            });
          } else {
            this.snackBar.open(response.payload.message, "OK", {
              duration: 3000,
            });
          }
        },
        (error) => {
          this.snackBar.open("Error updating password", "OK", {
            duration: 3000,
          });
        }
      );
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/common/profile/profile.component.ts